import getSipUri from './getSipUri';
import isSignedIn from './isSignedIn';
import getPresence from '../services/getPresence';
import { isFeatureEnabled } from 'owa-feature-flags';

const DEFAULT_TIME_TO_WAIT_TO_BATCH_GET_PRESENCE_REQUESTS = 5000;
let pendingGetPresenceUris: string[] = [];
let batchGetPresenceRequestsTimer = null;

// This function is used to update the presence in
// 1. RP sender image in expanded/collapsed item part
// 2. Compose readwrite recipient well
export default function tryRegisterForPresenceUpdates(imAddress: string) {
    if (!isFeatureEnabled('fwk-skypeBusinessV2')) {
        return;
    }

    if (!isSignedIn()) {
        return;
    }

    if (!imAddress) {
        return;
    }
    const sipUri = getSipUri(imAddress);
    addOrUpdatePendingGetRequests(sipUri);
}

function addOrUpdatePendingGetRequests(sipUri: string) {
    if (pendingGetPresenceUris.includes(sipUri)) {
        return;
    }
    pendingGetPresenceUris.push(sipUri);
    if (!batchGetPresenceRequestsTimer) {
        batchGetPresenceRequestsTimer = window.setTimeout(() => {
            batchGetPresenceRequestsTimer = null;
            if (pendingGetPresenceUris.length > 0) {
                getPresence(pendingGetPresenceUris);
                pendingGetPresenceUris = [];
            }
        }, DEFAULT_TIME_TO_WAIT_TO_BATCH_GET_PRESENCE_REQUESTS);
    }
}
